import React, { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import ServiceDetails from "../services/ServiceData";
import { useLanguage } from './../common/LanguageContext';
import "../styles/KeyFeatureAndTopBenefits.css";

const KeyFeatureAndTopBenefits = ({ serviceName }) => {
  const { t } = useTranslation();
  const [showMoreKeyFeatures, setShowMoreKeyFeatures] = useState(false);
  const [showMoreTopBenefits, setShowMoreTopBenefits] = useState(false);
  const [isKeyFeaturesLong, setIsKeyFeaturesLong] = useState(false);
  const [isTopBenefitsLong, setIsTopBenefitsLong] = useState(false);
  const { language } = useLanguage();

  const keyFeaturesRef = useRef(null);
  const topBenefitsRef = useRef(null);

  const serviceContent = {
    smr_bots_title: {
      keyFeatures: t("smr_bots_key_features"),
      topBenefits: t("smr_bots_top_benefits"),
    },
    psf_bots_title: {
      keyFeatures: t("psf_bots_key_features"),
      topBenefits: t("psf_bots_top_benefits"),
    },
  };
  
  /*const { keyFeatures, topBenefits } = serviceContent[title] || {
   keyFeatures: t("key_features_unavailable"),

    topBenefits: t("top_benefits_unavailable"),
  };*/
const [keyFeatures, setKeyFeatures] = useState([]);
const [ topBenefits, setTopBenefits] = useState([]);
  useEffect(() => {
   
    const fetchServices = async () => {
          try {
            const responseData = await ServiceDetails.serviceDetails(`${language}`,serviceName);
            
          
           setKeyFeatures(responseData.serviceInfo.SERVICE_FEATURES)
           setTopBenefits(responseData.serviceInfo.SERVICE_BENEFITS)
          
              
           
             
           
            
            
          } catch (error) {
            console.error("Error fetching service plans:", error);
          }
        };
    
        fetchServices();
    if (keyFeaturesRef.current) {
      setIsKeyFeaturesLong(
        keyFeaturesRef.current.scrollHeight > keyFeaturesRef.current.offsetHeight
      );
    }
    if (topBenefitsRef.current) {
      setIsTopBenefitsLong(
        topBenefitsRef.current.scrollHeight > topBenefitsRef.current.offsetHeight
      );
    }
  }, [keyFeatures, topBenefits, serviceName,language]); 

  const toggleShowMoreKeyFeatures = () => {
    setShowMoreKeyFeatures(!showMoreKeyFeatures);
  };

  const toggleShowMoreTopBenefits = () => {
    setShowMoreTopBenefits(!showMoreTopBenefits);
  };

  return (
    <div className="key-benefits-container">
      <h2 className="h5">{t("key_features")}</h2>
      <div
        className={`text-secondary ${showMoreKeyFeatures ? "expanded" : "collapsed"}`}
        ref={keyFeaturesRef}
      >
        {keyFeatures}
        
      </div>
      {isKeyFeaturesLong && !showMoreKeyFeatures && (
        <div className="learn-more-container">
          <a
            href="#"
            className="learn-more-link"
            onClick={(e) => {
              e.preventDefault();
              toggleShowMoreKeyFeatures();
            }}
          >
            {t("learn_more")}
            <span className="chevron-icon">
              <FontAwesomeIcon icon={faChevronRight} />
            </span>
          </a>
        </div>
      )}

      <div className="divider"></div>

      <h2 className="h5">{t("our_top_benefits")}</h2>
      <div
        className={`text-secondary ${showMoreTopBenefits ? "expanded" : "collapsed"}`}
        ref={topBenefitsRef}
      >
        {topBenefits}
      </div>
      {isTopBenefitsLong && !showMoreTopBenefits && (
        <div className="learn-more-container">
          <a
            href="#"
            className="learn-more-link"
            onClick={(e) => {
              e.preventDefault();
              toggleShowMoreTopBenefits();
            }}
          >
            {t("learn_more")}
            <span className="chevron-icon">
              <FontAwesomeIcon icon={faChevronRight} />
            </span>
          </a>
        </div>
      )}
    </div>
  );
};

export default KeyFeatureAndTopBenefits;
